import { render, staticRenderFns } from "./SuperPartnerList.vue?vue&type=template&id=0b3bca4e&scoped=true"
import script from "./SuperPartnerList.vue?vue&type=script&lang=js"
export * from "./SuperPartnerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3bca4e",
  null
  
)

export default component.exports